import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./components/ProtectedRoute";
import { AllRoutes } from "./config/routes";
import Dashboard from "./pages/Dashboard/Dashboard";
import HoursSummary from "./pages/hours/HoursSummary";
import Home from "./pages/home";
import ProjectDetail from "./pages/projects/ProjectDetail";
import Projects from "./pages/projects/Projects";
import SignInPage from "./pages/sign-in/SignInPage";
import theme from "./theme/theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Router>
          <Routes>
            <Route path={AllRoutes.Home} element={<Home />} />
            <Route path={AllRoutes.Dashboard} element={<Dashboard />} />
            <Route path={`${AllRoutes.SignIn}/*`} element={<SignInPage />} />
            <Route
              path={`${AllRoutes.Hours}/:projectId`}
              element={<HoursSummary />}
            />
            <Route
              path={AllRoutes.Projects}
              element={
                <ProtectedRoute>
                  <Projects />
                </ProtectedRoute>
              }
            />
            <Route
              path={`${AllRoutes.Projects}/:projectId`}
              element={
                <ProtectedRoute>
                  <ProjectDetail />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
